import './assets/css/custom.css';

import Vue from "vue";
import VueCardFormat from "vue-credit-card-validation";
import VueGtag from "vue-gtag";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib";

import getEnv from "@/config/env";
import {CAPTCHA_SITE_KEY} from "@/global/_constants";
import { authorize, hasProjectAccessFor, isFeatureEnabled, isLoggedInUser, isSectionEnabled, getNoTabPermissionMessage, hasEnabledSection } from "@/helpers/helper";
import { pRole, Role } from "@/helpers/role";
import ipCheckPlugin from "@/plugins/ipCheckPlugin";
import {reCaptchaPlugin} from "@/plugins/recaptchaPlugin";
import SocketPlugin from "@/plugins/socket";
import tokenizerPlugin from "@/plugins/tokenizerPlugin";
import TokenRefreshPlugin from "@/plugins/tokenRefreshPlugin";

import App from "./App.vue";
import sentry from "./plugins/sentry";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/index";

// Make Role and authorize available globally
Vue.prototype.$role = Role;
Vue.prototype.$authorize = authorize;

//for project level access control
Vue.prototype.$pRole = pRole;
Vue.prototype.$hasProjectAccessFor = hasProjectAccessFor;
Vue.prototype.$isFeatureEnabled = isFeatureEnabled;
Vue.prototype.$isSectionEnabled = isSectionEnabled;
Vue.prototype.$getNoTabPermissionMessage = getNoTabPermissionMessage;
Vue.prototype.$hasEnabledSection = hasEnabledSection;
Vue.prototype.$isLoggedInUser = isLoggedInUser;
Vue.config.productionTip = false;

Vue.use(ipCheckPlugin);
Vue.use(reCaptchaPlugin, {siteKey: CAPTCHA_SITE_KEY});
Vue.use(VueTelInputVuetify, {vuetify});
Vue.use(VueCardFormat);
Vue.use(VueGtag, {
  config: { id: "G-1D4B3FSF7Z" },
  enabled: getEnv("NODE_ENV") === 'production',
});
Vue.use(TokenRefreshPlugin);
Vue.use(SocketPlugin, { store });
Vue.use(tokenizerPlugin);

new Vue({
  router,
  store,
  vuetify,
  sentry,
  render: (h) => h(App),
}).$mount("#app");
